export default __webpack_public_path__ + "static/lb-11-3828f960a396049825b5f59298359461.webp";